export let words = [
  "besøke",
"norsk",
"mye",
"annen",
"under",
"to",
"artikkel",
"få",
"hos",
"år",
"stor",
"føde",
"første",
"and",
"oktober",
"komme",
"ta",
"arkivere",
"finnes",
"navn",
"januar",
"bilde",
"august",
"mars",
"tidlig",
"oslo",
"norge",
"kort",
"ny",
"desember",
"art",
"april",
"engelsk",
"kommune",
"god",
"september",
"mai",
"bruke",
"ligge",
"slekt",
"juli",
"død",
"juni",
"blant",
"gå",
"november",
"spille",
"del",
"video",
"lyd",
"februar",
"tre",
"sen",
"tall",
"tid",
"utvide",
"sammen",
"gjøre",
"hjelpe",
"vinne",
"kategori",
"land",
"se",
"wikipedia",
"dag",
"gammel",
"mangelfull",
"offisiell",
"foreløpig",
"kjent",
"små",
"side",
"utfylle",
"familie",
"tysk",
"new",
"amerikansk",
"gruppe",
"skrive",
"lang",
"monark",
"nord",
"lag",
"gjennom",
"mens",
"delta",
"område",
"film",
"kalle",
"følge",
"original",
"USA",
"rundt",
"sted",
"sør",
"begynne",
"nettsted",
"la",
"finne",
"tilbake",
"kirke",
"bygge",
"OL",
"sommer",
"london",
"mann",
"utgi",
"sist",
"gang",
"medlem",
"høy",
"plass",
"svensk",
"fire",
"kamp",
"stå",
"åre",
"portal",
"hel",
"konge",
"fransk",
"ham",
"representere",
"sette",
"database",
"størst",
"president",
"periode",
"bestå",
"person",
"arbeide",
"historie",
"igjen",
"føre",
"britisk",
"sønn",
"viktig",
"rekke",
"skole",
"andre",
"starte",
"holde",
"først",
"album",
"øye",
"dansk",
"sitte",
"PDF",
"serie",
"slutt",
"statistikk",
"vest",
"sverige",
"grunn",
"velge",
"oppføre",
"forfatter",
"tyskland",
"tillegg",
"forskjellig",
"VM",
"internet",
"kvinne",
"slå",
"internasjonal",
"vise",
"ord",
"tv",
"statsminister",
"øst",
"liste",
"eksempel",
"olympisk",
"barn",
"liv",
"vei",
"vid",
"press",
"frem",
"bruk",
"rett",
"krig",
"danmark",
"leder",
"sesong",
"døde",
"måtte",
"levere",
"like",
"band",
"sang",
"global",
"elv",
"inneholde",
"informasjon",
"lede",
"vanlig",
"bok",
"imidlertid",
"innbygger",
"deretter",
"løp",
"information",
"sende",
"england",
"bergen",
"fem",
"frankrike",
"lage",
"resultat",
"selskap",
"opprinnelig",
"reise",
"europa",
"ganger",
"dele",
"utvikle",
"derfor",
"ulike",
"arrangere",
"innen",
"hele",
"sterk",
"flytte",
"politisk",
"russisk",
"legge",
"NRK",
"rolle",
"språk",
"særlig",
"basere",
"parti",
"dermed",
"møte",
"hvert",
"gull",
"etablere",
"må",
"tilhøre",
"verdenskrig",
"drive",
"regne",
"styrke",
"svær",
"betydning",
"støtte",
"million",
"fram",
"klubbe",
"nummer",
"mål",
"online",
"skuespiller",
"form",
"kina",
"liten",
"egen",
"ende",
"benytte",
"paris",
"opprette",
"danne",
"spesiell",
"endre",
"hjelp",
"kinesisk",
"kjenne",
"bak",
"tittel",
"samtidig",
"verden",
"spiller",
"antall",
"menneske",
"detaljert",
"produsere",
"verk",
"slag",
"koordinat",
"mene",
"deler",
"direkte",
"provins",
"nær",
"roman",
"grense",
"omtale",
"orden",
"inkludere",
"enkelt",
"david",
"robert",
"fly",
"hus",
"italiensk",
"forhold",
"is",
"hertug",
"storbritannia",
"skip",
"thomas",
"sentral",
"fortsette",
"fylke",
"langs",
"forlag",
"gire",
"seks",
"alt",
"beskrive",
"nyte",
"gresk",
"musikk",
"italia",
"leksikon",
"åpne",
"vann",
"ansette",
"folk",
"drepe",
"grad",
"ønske",
"selge",
"kong",
"biografi",
"politiker",
"eneste",
"klasse",
"arkivert",
"universitet",
"regjering",
"system",
"bror",
"trekke",
"fotball",
"datter",
"games",
"stamme",
"tredje",
"kanskje",
"befolkning",
"vokse",
"midt",
"klare",
"gjerne",
"moderne",
"forbindelse",
"militær",
"oversikt",
"versjon",
"bille",
"nasjonal",
"berlin",
"vinter",
"lokal",
"football",
"friidrett",
"greve",
"finale",
"måte",
"visere",
"allerede",
"tekst",
"olympic",
"innenfor",
"delstat",
"samle",
"gate",
"fotballspiller",
"utenfor",
"skje",
"far",
"stat",
"michael",
"russland",
"brasil",
"time",
"fortsatt",
"james",
"omfatte",
"region",
"grunnlegge",
"hvit",
"list",
"martin",
"lov",
"bygning",
"sølv",
"bety",
"trondheim",
"statens",
"historisk",
"tom",
"spansk",
"utgave",
"museum",
"mulig",
"bo",
"runde",
"fylkesvei",
"verdens",
"fjell",
"høre",
"omkring",
"århundre",
"lære",
"studere",
"gift",
"lite",
"tape",
"erik",
"ifølge",
"divisjon",
"galleri",
"utnevne",
"george",
"afrika",
"program",
"fri",
"litt",
"gitar",
"total",
"store",
"larve",
"utvikling",
"fast",
"hente",
"keiser",
"europeisk",
"ti",
"professor",
"kjøpe",
"overta",
"skape",
"aftenposten",
"lenke",
"ung",
"uoffisiell",
"japan",
"øvre",
"nesten",
"gruppen",
"NM",
"love",
"le",
"publisere",
"gård",
"rask",
"vanligvis",
"offentlig",
"canada",
"motta",
"katolsk",
"mor",
"los",
"spania",
"foran",
"romersk",
"litteratur",
"kraftig",
"van",
"dra",
"uke",
"stavanger",
"svart",
"utbre",
"ei",
"red",
"lav",
"general",
"tildele",
"stille",
"kreve",
"kilde",
"australia",
"nevne",
"organisasjon",
"dagens",
"stockholm",
"type",
"angrep",
"knytte",
"gifte",
"blive",
"avis",
"vite",
"aktiv",
"økonomisk",
"prise",
"populær",
"eie",
"hansen",
"valg",
"utgjøre",
"be",
"aldri",
"nordlig",
"begynnelse",
"øke",
"via",
"eget",
"india",
"bind",
"park",
"linje",
"amerika",
"trelise",
"ride",
"fortelle",
"egne",
"skade",
"hit",
"seier",
"konkurrere",
"sanger",
"omtrent",
"hete",
"lars",
"lys",
"neste",
"bøk",
"oppdage",
"kropp",
"plassere",
"stasjon",
"erstatte",
"peke",
"dekke",
"forlate",
"rik",
"universitetet",
"rest",
"plan",
"hav",
"jobbe",
"distrikt",
"produksjon",
"fikk",
"spill",
"maria",
"bronse",
"rød",
"hjemmeside",
"hode",
"roma",
"voksen",
"tradisjonell",
"stortinget",
"utføre",
"hær",
"ettersom",
"EM",
"riktig",
"mesterskap",
"måned",
"konkurranse",
"sørlig",
"nok",
"nederlandsk",
"stilling",
"åtte",
"soldat",
"forsøke",
"betydelig",
"artist",
"forening",
"hovedstad",
"problem",
"ganske",
"island",
"full",
"tilsvare",
"poeng",
"sentrum",
"høst",
"areal",
"knut",
"dyr",
"krone",
"bestemme",
"oppstå",
"biskop",
"bryte",
"kunst",
"par",
"kilometer",
"bane",
"live",
"sultan",
"blad",
"københavn",
"episode",
"hovedsakelig",
"hevde",
"topp",
"japansk",
"likevel",
"finland",
"leke",
"produsent",
"tross",
"arbeid",
"bidra",
"betegnelse",
"bred",
"endring",
"kultur",
"fare",
"cup",
"trøndelag",
"karriere",
"pave",
"summer",
"åpen",
"makt",
"asia",
"venn",
"hverandre",
"utdype",
"athletics",
"fungere",
"medalje",
"data",
"inntil",
"prosjekt",
"kristen",
"musiker",
"hjem",
"stein",
"henry",
"begrep",
"friidrettsutøver",
"ordenen",
"sider",
"inngå",
"stifte",
"mangle",
"gud",
"overfamilien",
"dårlig",
"samling",
"journal",
"beijing",
"tjeneste",
"baby",
"rock",
"gjennomføre",
"sport",
"korea",
"mørk",
"tilfelle",
"landets",
"nordisk",
"avdeling",
"hendelse",
"nederland",
"info",
"vokal",
"radio",
"angeles",
"dessuten",
"california",
"biller",
"gjelde",
"start",
"høyde",
"fremst",
"mark",
"vegvesen",
"eksistere",
"TV",
"VG",
"ferdig",
"høyre",
"indre",
"tro",
"senter",
"slutte",
"ledelse",
"nettside",
"vestlig",
"teater",
"tettsted",
"samfunn",
"polen",
"web",
"virksomhet",
"avtale",
"utg",
"mexico",
"johannes",
"egypt",
"bjørn",
"renne",
"mester",
"fall",
"variere",
"lenger",
"link",
"styre",
"anta",
"mulighet",
"ødelegge",
"bydel",
"dronning",
"plate",
"marie",
"arkitekt",
"song",
"ski",
"kardinal",
"vanskelig",
"synge",
"fauna",
"virke",
"heller",
"ni",
"elev",
"studium",
"dagbladet",
"sosial",
"leite",
"hall",
"tilgjengelig",
"personlig",
"dikt",
"re",
"generell",
"lengre",
"kraftverk",
"myndighet",
"vedlikehold",
"bære",
"ordfører",
"lese",
"komponist",
"anlegg",
"modell",
"nivå",
"tema",
"enten",
"musikkalbum",
"kontroll",
"samarbeid",
"kor",
"innføre",
"anders",
"student",
"sovjetunionen",
"avslutte",
"hard",
"profil",
"sogn",
"dekkvinge",
"forsøk",
"tour",
"forskning",
"institutt",
"leve",
"redusere",
"landslag",
"sommerfugl",
"kunstner",
"komit",
"oppkalle",
"bosette",
"rette",
"peker",
"portugisisk",
"trolig",
"biografisk",
"social",
"lee",
"representant",
"oppnå",
"grave",
"østerrike",
"antenne",
"egentlig",
"venstre",
"jord",
"privat",
"do",
"irland",
"årets",
"rom",
"union",
"journalist",
"innsjø",
"variant",
"landsby",
"utøver",
"redaktør",
"dato",
"royal",
"population",
"klassisk",
"prøve",
"kjøre",
"rekord",
"dersom",
"tegne",
"spre",
"tromme",
"team",
"lengde",
"suksess",
"søke",
"interesse",
"berg",
"male",
"båt",
"relativ",
"falle",
"prest",
"fullføre",
"handle",
"krav",
"direktør",
"sovjetisk",
"alder",
"stadig",
"motor",
"sørøst",
"sveits",
"bass",
"ansvar",
"kristiania",
"lufthavn",
"fjerde",
"egenskap",
"utgivelse",
"alltid",
"polsk",
"punkt",
"utdanne",
"tidsskrift",
"bevegelse",
"planlegge",
"israel",
];

export default words;